import { IComponentManifest, IHostManifest } from '../../registry.types';
import {
  getExtension,
  isJS,
  getAssetsTypeByExtension,
} from '../../toolbox/assets';
import { createComponentManifestBuilder } from './componentsManifestBuilder';

export function createHostManifestBuilder({ host }: { host: string }) {
  const hostManifest: IHostManifest = {
    host,
    assets: [],
    components: {},
    statics: {},
  };

  const componentBuilders: Record<
    string,
    ReturnType<typeof createComponentManifestBuilder>
  > = {};

  return {
    addUrl(id: string, url: string) {
      hostManifest.id = id;
      hostManifest.url = url;

      this.addModelAsset(id, url);

      return this;
    },
    addComponentStatics(componentName: string, statics: Record<string, any>) {
      hostManifest.statics[componentName] = statics;

      return this;
    },

    addRuntimeAsset(url: string) {
      hostManifest.assets.push({
        url,
        type: 'webpack-runtime',
        extension: 'js',
      });

      return this;
    },
    addHotAsset(url: string) {
      hostManifest.assets.push({
        url,
        type: 'hot',
        extension: 'js',
      });

      return this;
    },
    addModelAsset(id: string, url: string) {
      hostManifest.assets.push({
        id,
        url,
        type: 'model',
        extension: 'js',
      });

      return this;
    },
    addStyleAsset(url: string) {
      hostManifest.assets.push({
        url,
        type: 'style',
        extension: 'css',
      });

      return this;
    },
    getComponentBuilder(name: string) {
      if (!componentBuilders[name]) {
        componentBuilders[name] = createComponentManifestBuilder({
          name,
        });
      }

      return componentBuilders[name];
    },

    addDeps(deps: Array<string>) {
      hostManifest.deps = deps.filter(url => isJS(getExtension(url)));
      hostManifest.assets.push(
        ...deps.map(url => {
          const extension = getExtension(url) as string;

          return {
            url,
            type: getAssetsTypeByExtension(extension),
            extension,
            dependency: true,
          };
        }),
      );
    },

    build() {
      const state = { ...hostManifest };

      const components: Record<string, IComponentManifest> = {};

      Object.keys(componentBuilders).forEach(componentName => {
        components[componentName] = componentBuilders[componentName].build();
      });

      return { ...state, components };
    },
  };
}
